<div *ngIf="!items.length" class="wrapper-no-item">
  <img src="../../../../../assets/images/empty_map.svg" alt="">
  <span>
    {{'NEAR_YOU_PAGE.no_items_found_near_your_location' | translate}}
  </span>
</div>
<div *ngIf="items.length && !areItemsSelected" class="wrapper-list-items">
  <div *ngFor="let singleItem of items" (click)="selectItem(singleItem)" class="wrapper-card-item">
    <div class="wrapper-card-left">
      <img class="image-item"
        [src]="singleItem?.items[0]?.lyst_item_image_url ? singleItem?.items[0]?.lyst_item_image_url : 'assets/images/no-image.png'"
        alt="">
      <div class="wrapper-info-item">
        <div class="label-name">{{singleItem?.items[0]?.name}}</div>
        <div class="label-by">{{singleItem?.items[0]?.by}}</div>
      </div>
    </div>
    <div class="wrapper-card-right">
      <img src="../../../../../assets/icons/rating/icon-star-fill.svg" alt="">
      <span>{{singleItem?.items[0]?.average_rating}}</span>
    </div>
  </div>
</div>
<div *ngIf="areItemsSelected" class="wrapper-list-items">
  <div *ngFor="let singleItem of items" (click)="selectItem(singleItem)" class="wrapper-card-item">
    <div class="wrapper-card-left">
      <img class="image-item"
        [src]="singleItem?.lyst_item_image_url ? singleItem?.lyst_item_image_url : 'assets/images/no-image.png'"
        alt="">
      <div class="wrapper-info-item">
        <div class="label-name">{{singleItem?.name}}</div>
        <div class="label-by">{{singleItem?.by}}</div>
      </div>
    </div>
    <div class="wrapper-card-right">
      <img src="../../../../../assets/icons/rating/icon-star-fill.svg" alt="">
      <span>{{singleItem?.average_rating}}</span>
    </div>
  </div>
</div>
